import {select} from 'd3-selection';

function bindOn(node, dispatch) {
  node.on('click.default', function() {
    dispatch.apply('selectClick', this, arguments); 
  }).on('mouseenter.default', function() {
    dispatch.apply('selectEnter', this, arguments);
  }).on('mouseleave.default', function() {
    dispatch.apply('selectLeave', this, arguments);
  })
  return node;
}
function render(keep = true) { //keep인 경우 지난 스케일을 유지
  this.renderLayout(keep);
  if (!this.__execs__.canvas) return;
  this.__execs__.canvas.style('pointer-events', 'none')
    .transition().duration(this.transition().duration).delay(this.transition().delay)
    .on('end', function() {
      select(this).style('pointer-events', 'all');
    })
  
  const dispatch = this.__execs__.selectDispatch;
  const node = this.nodes();
  const legend = this.__execs__.legend;
  if (node && node.size() > 0) { 
    if (this.parent()) {
      return;
    }
    node.call(bindOn, dispatch)
      .on('mouseenter.default.legend', (d) => {
        if (legend && legend.mute && this.muteToLegend) this.muteToLegend(d);
      }).on('mouseleave.default.legend', (d) => {
        if (legend && legend.demute && this.demuteToLegend) this.demuteToLegend(d);
      })
  }

  if (this.isFacet && this.isFacet()) { //facet인 경우 부모 레이아웃에는 nodes가 없으므로 region에서 받아옴
    node.call(bindOn, dispatch);
  }
  return this;
}

export default render;


// WEBPACK FOOTER //
// ./layouts/default/render.js